<template>
  <div>
    <Navbar/>
    <Header/>
    <PartnerComp/>
    <PersonalityNew/>
    <Mission/>
    <Services/>
    <Advisors/>
    <Location/>
    <GetInTouch/>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Header from "./Header";
import PartnerComp from "./PartnerCompany";
import PersonalityNew from "./PersonalityNew";
import Mission from "./Mission";
import Services from "./Services";
import Advisors from "./Advisors";
import Location from "./Location";
import GetInTouch from "./GetInTouch";
import Footer from "./Footer";

export default {
  name: "Main",
  components: {
    Navbar,
    Location,
    PartnerComp,
    Advisors,
    Services,
    PersonalityNew,
    Mission,
    Header,
    GetInTouch,
    Footer
  },
  created() {
    this.$store.commit("SET_PAGE_TYPE", "aboutUs");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)");
    // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
  }
}
</script>

<style scoped>
</style>
